import Products from "./Products";

const AllProducts = () => {
  return (
    <div>
      <section>
        <Products></Products>
      </section>
    </div>
  );
};

export default AllProducts;
